import React from 'react'
import { Link } from 'react-router-dom'

import NavBarContent from '../navbar/NavBarContent'
import CheckIcon from '../../../static/images/check.svg'
import Button, { ButtonSize, ButtonVariant } from '../../../components/ui/button'
import { ReactComponent as StarIcon } from '../../../static/images/star.svg'
import './styles.scss'

type Props = { children: string }

const Feature: React.FC<Props> = ({ children }) => (
  <div className='d-inline-flex align-items-center px-2'>
    <img className='me-2' width='28' src={CheckIcon} alt='check icon invoice' />
    {children}
  </div>
)

export type HeroContentProps = {
  onSignIn?: () => void
  onSignInMicrosoft?: () => void
  staticLinks?: boolean
  onScrollToForm?: () => void
  scrollToFormHref?: string
}

const scrollToGuestForm = () => {
  document.getElementById('guest-invoice-form')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

const HeroContent = ({
  staticLinks,
  onScrollToForm,
  scrollToFormHref = '#guest-invoice-form',
}: HeroContentProps) => (
  <>
    <header role='banner'>
      <NavBarContent staticLinks={staticLinks} />
    </header>
    <main className='container col-xxl-8 py-4' id='main-content' role='main'>
      <section className='text-center' aria-labelledby='hero-heading'>
        <h1 id='hero-heading' className='text-primary display-4 sm:display-1 mt-2 col-md-12 mx-auto'>
          Simple invoice generator<br />
          <i className='text-tertiary display-5 pt-1 sm:display-1'>Create & Send Invoices Fast</i>
        </h1>
        <div className='my-5 col-8 col-md-12 mx-auto text-start text-md-center opacity-75' role='list' aria-label='Features'>
          <Feature>Send Professional PDF Invoices</Feature>
          <Feature>Multiple Currencies</Feature>
          <Feature>Automatic Payment Reminder Emails</Feature>
        </div>

        <div className='d-flex flex-column flex-md-row gap-3 justify-content-center align-items-center mb-4'>
          {staticLinks ? (
            <a href={scrollToFormHref} className='btn btn-primary btn-lg px-4'>
              Create an invoice
            </a>
          ) : (
            <>
              <Link to='/login'>
                <Button variant={ButtonVariant.LIGHT} size={ButtonSize.LARGE}>
                  Sign in
                </Button>
              </Link>
              <Button variant={ButtonVariant.PRIMARY} size={ButtonSize.LARGE} onClick={onScrollToForm ?? scrollToGuestForm}>
                Create your first invoice
              </Button> 
              
            </>
          )}
        </div>
        <div className='pt-2 z-3 position-relative d-flex gap-2 align-items-center justify-content-center'>
          <div>
            {Array.from({ length: 5 }, (_, i) => (
              <StarIcon width={10} className='hero-stars' />
            ))}
          </div>
          <div className=''><small className='text-muted'>Trusted by 1200+ businesses</small></div>
        </div>
      </section>
    </main>
  </>
)

export default HeroContent
